// AG related products: fetch this section rendered with Shopify's
// recommendations for the current product and swap the markup in.
class AgRelatedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.performed === 'true') return;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      this.#load();
    }, { rootMargin: '600px 0px' });
    io.observe(this);
  }
  async #load() {
    try {
      const res = await fetch(this.dataset.url);
      if (!res.ok) { this.#dismiss(); return; }
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = html.querySelector('ag-related-products');
      if (fresh?.querySelector('.ag-plist__grid')) this.replaceWith(fresh);
      else this.#dismiss();
    } catch (e) { this.#dismiss(); }
  }

  // An empty section still carries its padding, which reads as a blank band on
  // the PDP. Remove it instead - except in the theme editor, where the merchant
  // still needs to be able to select the section.
  #dismiss() {
    if (window.Shopify?.designMode) return;
    this.remove();
  }
}
if (!customElements.get('ag-related-products')) customElements.define('ag-related-products', AgRelatedProducts);
